import React from "react";
import { Column } from "@/shared/ui/Blocks";
import { Card } from "../Card";
import { SubtitleText } from "@/shared/ui/Typography";
import { ProductNewsFeedItem } from "@/shared/hooks/content/useProductNewsFeed";

export interface NewsFeedItemProps extends ProductNewsFeedItem {}

const NewsFeedItem = (props: NewsFeedItemProps) => {
  const { title, url, description, createdAt, image, author } = props;

  const handleItemClick = () => {
    window.open(url, "_blank");
  };

  return (
    <Card
      className="flex overflow-hidden flex-col  w-[200px] cursor-pointer group transition-all duration-300 hover:shadow-sm hover:shadow-gray-200"
      onClick={handleItemClick}
    >
      <Column className="h-[150px] w-[200px] overflow-hidden">
        <img
          src={image?.url || "/images/backgrounds/slide-blue.png"}
          alt={title}
          className="w-full h-full object-cover group-hover:scale-105 transition-all duration-300"
        />
      </Column>
      <Column className=" bg-white p-2 min-h-[64px] gap-1">
        <h6 className="font-semibold text-xs">{title}</h6>
        {description && (
          <SubtitleText size="small" className="leading-tight line-clamp-2">
            {description}
          </SubtitleText>
        )}
      </Column>
    </Card>
  );
};

export default NewsFeedItem;
